import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Drawer,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Divider,
  MenuItem,
  TextField,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import PeopleIcon from "@mui/icons-material/People";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import KPICard from "../KPIs/KPICard";
import { calcularRQ13 } from "../KPIs/engine/rq13Engine";
import {
  getCycleMeta,
  getCycleMetaFromResposta,
  isDateWithinCycle,
} from "../KPIs/ciclo.utils";
import { useHistory, useLocation } from "react-router-dom";
import { SIDEBAR_ITEMS } from "../Config/sidebarItems";
import { usePermissoesAcesso } from "../Utils/permissoesAcesso";


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";

import { Bar, Doughnut } from "react-chartjs-2";

import {
  collection,
  onSnapshot,
  query,
  where,
  getDoc,
  getDocs,   // 👈 FALTAVA ISSO
  doc,
} from "firebase/firestore";


import { db } from "../Config/firebase";
import { getUsuarioAtualComTenant, tenantWhere } from "../Utils/tenant";

/* ================= CHART SETUP ================= */
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  ChartTooltip,
  Legend
);
     const tipoUsuario =
  (localStorage.getItem("tipoUsuario") || "cliente").toLowerCase();




function mesAtualParaInput() {
  const agora = new Date();
  return `${agora.getFullYear()}-${String(agora.getMonth() + 1).padStart(2, "0")}`;
}

function normalizarChaveObra(valor) {
  return String(valor || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
}

function respostaPertenceAoCicloAtual(resposta, kpi, cicloAtual) {
  if (resposta.ciclo === cicloAtual.chave) return true;
  if (isDateWithinCycle(resposta.createdAt, cicloAtual)) return true;

  const cicloResposta = getCycleMetaFromResposta({
    createdAt: resposta.createdAt,
    ciclo: resposta.ciclo,
    ano: resposta.ano,
    cicloNumero: resposta.cicloNumero ?? resposta.trimestre,
    periodicidade: kpi.periodicidadeCiclos ?? resposta.periodicidadeCiclos,
  });

  return (
    cicloResposta.ano === cicloAtual.ano &&
    cicloResposta.cicloNumero === cicloAtual.cicloNumero
  );
}

function periodoAtual(tipo, mesReferencia = mesAtualParaInput()) {
  const agora = new Date();
  let inicio;
  let fim;

  if (tipo === "anual") {
    inicio = new Date(agora.getFullYear(), 0, 1);
    fim = new Date(agora.getFullYear() + 1, 0, 1);
  } else if (tipo === "mensal") {
    const [anoInformado, mesInformado] = String(mesReferencia).split("-").map(Number);
    const ano = Number.isInteger(anoInformado) ? anoInformado : agora.getFullYear();
    const mes = Number.isInteger(mesInformado) ? mesInformado - 1 : agora.getMonth();
    inicio = new Date(ano, mes, 1);
    fim = new Date(ano, mes + 1, 1);
  } else {
    inicio = new Date(agora);
    const diasDesdeSegunda = (agora.getDay() + 6) % 7;
    inicio.setDate(agora.getDate() - diasDesdeSegunda);
    inicio.setHours(0, 0, 0, 0);
    fim = new Date(inicio);
    fim.setDate(inicio.getDate() + 7);
  }

  return { inicio, fim };
}

function descricaoMes(mesReferencia) {
  const { inicio } = periodoAtual("mensal", mesReferencia);
  const descricao = inicio.toLocaleDateString("pt-BR", {
    month: "long",
    year: "numeric",
  });
  return descricao.charAt(0).toUpperCase() + descricao.slice(1);
}

function dataOrdemServico(ordem) {
  if (typeof ordem?.data === "string") {
    const [ano, mes, dia] = ordem.data.split("-").map(Number);
    if (ano && mes && dia) return new Date(ano, mes - 1, dia);
  }
  if (ordem?.criadoEm?.toDate) return ordem.criadoEm.toDate();
  return null;
}

function dataRegistroEnsaio(registro, campos = []) {
  for (const campo of campos) {
    const valor = registro?.[campo];
    if (!valor) continue;
    if (valor instanceof Date) return valor;
    if (valor?.toDate) return valor.toDate();
    if (typeof valor === "string") {
      const [ano, mes, dia] = valor.split("-").map(Number);
      if (ano && mes && dia) return new Date(ano, mes - 1, dia);
    }
  }
  return null;
}

function quebrarRotuloGrafico(valor, limite = 28) {
  const palavras = String(valor || "").trim().split(/\s+/).filter(Boolean);
  const linhas = [];
  palavras.forEach((palavra) => {
    const ultima = linhas[linhas.length - 1];
    if (!ultima || `${ultima} ${palavra}`.length > limite) linhas.push(palavra);
    else linhas[linhas.length - 1] = `${ultima} ${palavra}`;
  });
  return linhas.length ? linhas : ["Empresa não informada"];
}

function podeVerKPI(escopo, tipoUsuario) {
  if (tipoUsuario === "colaborador") return false;
  if (tipoUsuario === "admin") return true; // 🔥 ADMIN VÊ TUDO

  if (!escopo) return false;

  if (escopo === "cliente") return tipoUsuario === "cliente";

  if (escopo === "colaborador")
    return tipoUsuario === "colaborador";

  if (escopo === "cliente_colaborador")
    return tipoUsuario === "cliente" || tipoUsuario === "colaborador";

  if (escopo === "interno")
    return tipoUsuario !== "cliente";

  return false;
}
function getAllSidebarItems() {
  return Object.values(SIDEBAR_ITEMS)
    .flat()
    .flatMap(item => item.children ? [item, ...item.children] : [item])
    .filter(item => item.path);
}



export default function DashboardContent({
  quickAccessEnabled,
  setQuickAccessEnabled,
  tipoUsuario: tipoUsuarioProp,
}) {

  const history = useHistory();
  const { podeAcessarItem } = usePermissoesAcesso();
const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [kpis, setKpis] = useState([]);
  const [rq13, setRq13] = useState(null);
  const [periodoEnsaios, setPeriodoEnsaios] = useState("mensal");
  const [mesEnsaios, setMesEnsaios] = useState(mesAtualParaInput);
  const [periodoRupturas, setPeriodoRupturas] = useState("anual");
  const [mesRupturas, setMesRupturas] = useState(mesAtualParaInput);
  const [ensaiosOSSemana, setEnsaiosOSSemana] = useState({
    tipos: [],
    totalEnsaios: 0,
    totalRealizados: 0,
    totalOrdens: 0,
    totalCadastros: 0,
    carregando: true,
  });
  const [rupturasPorObra, setRupturasPorObra] = useState({
    obras: [],
    totalCps: 0,
    carregando: true,
  });

  useEffect(() => {
    const abrirConfiguracao = () => setDrawerOpen(true);
    window.addEventListener("abrir-configuracao-dashboard", abrirConfiguracao);
    return () => window.removeEventListener("abrir-configuracao-dashboard", abrirConfiguracao);
  }, []);

  useEffect(() => {
    let unsubscribes = [];
    let cancelado = false;
    setEnsaiosOSSemana((atual) => ({ ...atual, carregando: true }));
    setRupturasPorObra((atual) => ({ ...atual, carregando: true }));

    async function ouvirTodosOsEnsaios() {
      try {
        const usuario = await getUsuarioAtualComTenant();
        if (cancelado) return;

        const fontes = { ordens: null, tracao: null, extracoes: null, dosagens: null, agenda: null, obras: null };
        let atualizacaoRupturas = 0;

        async function atualizarGraficoRupturas(moldagens, obrasCadastradas) {
          const atualizacao = ++atualizacaoRupturas;
          const { inicio, fim } = periodoAtual(periodoRupturas, mesRupturas);
          const moldagensDoPeriodo = moldagens
            .filter((moldagem) => moldagem.rupturaExterna !== true)
            .map((moldagem) => ({
              moldagem,
              indices: (moldagem.datasRuptura || [])
                .map((data, index) => ({ data: dataRegistroEnsaio({ data }, ["data"]), index }))
                .filter((item) => item.data && item.data >= inicio && item.data < fim)
                .map((item) => item.index),
            }))
            .filter((item) => item.indices.length > 0);

          setRupturasPorObra((atual) => ({ ...atual, carregando: true }));
          const caminhoesPorMoldagem = await Promise.all(
            moldagensDoPeriodo.map(async ({ moldagem, indices }) => {
              const snap = await getDocs(collection(db, "tblAgendaRuptura", moldagem.id, "caminhoes"));
              return {
                moldagem,
                indices,
                caminhoes: snap.docs.map((item) => item.data()),
              };
            })
          );
          if (cancelado || atualizacao !== atualizacaoRupturas) return;

          const obrasPorId = new Map(
            obrasCadastradas.map((obra) => [obra.id, obra])
          );
          const obrasPorNome = new Map();
          obrasCadastradas.forEach((obra) => {
            const chaveNome = normalizarChaveObra(obra.nome);
            if (!chaveNome) return;
            const obrasComMesmoNome = obrasPorNome.get(chaveNome) || [];
            obrasComMesmoNome.push(obra);
            obrasPorNome.set(chaveNome, obrasComMesmoNome);
          });

          function identificarObra(moldagem) {
            let obraCadastrada = obrasPorId.get(moldagem.obraId);

            if (!obraCadastrada) {
              const candidatas = obrasPorNome.get(normalizarChaveObra(moldagem.obra)) || [];
              obraCadastrada =
                candidatas.find((obra) =>
                  moldagem.clienteId && obra.clienteId === moldagem.clienteId
                ) || (candidatas.length === 1 ? candidatas[0] : null);
            }

            if (obraCadastrada) {
              return {
                chave: `id:${obraCadastrada.id}`,
                nome: String(obraCadastrada.nome || moldagem.obra || "").trim(),
              };
            }

            const nome = String(moldagem.obra || "").trim() || "Obra não informada";
            return {
              chave: `nome:${normalizarChaveObra(nome) || "nao-informada"}`,
              nome,
            };
          }

          const contagemPorObra = new Map();
          caminhoesPorMoldagem.forEach(({ moldagem, indices, caminhoes }) => {
            const obra = identificarObra(moldagem);
            const quantidadeCps = caminhoes
              .filter((caminhao) => caminhao.status !== "cancelado")
              .reduce((total, caminhao) => total + indices.reduce((subtotal, index) => {
                const resultado = caminhao.resultados?.[index];
                const valorCp1 = String(resultado?.cp1 ?? "").trim();
                const valorCp2 = String(resultado?.cp2 ?? "").trim();
                const cp1 = valorCp1 !== "" && Number.isFinite(Number(valorCp1.replace(",", ".")));
                const cp2 = valorCp2 !== "" && Number.isFinite(Number(valorCp2.replace(",", ".")));
                return subtotal + Number(cp1) + Number(cp2);
              }, 0), 0);
            if (quantidadeCps > 0) {
              const contagemAtual = contagemPorObra.get(obra.chave) || {
                obra: obra.nome,
                quantidade: 0,
              };
              contagemAtual.quantidade += quantidadeCps;
              contagemPorObra.set(obra.chave, contagemAtual);
            }
          });

          const obras = [...contagemPorObra.values()]
            .sort((a, b) => b.quantidade - a.quantidade || a.obra.localeCompare(b.obra, "pt-BR"));
          setRupturasPorObra({
            obras,
            totalCps: obras.reduce((total, item) => total + item.quantidade, 0),
            carregando: false,
          });
        }

        function atualizarGrafico() {
          if (cancelado || Object.values(fontes).some((itens) => itens === null)) return;

          const { inicio, fim } = periodoAtual(periodoEnsaios, mesEnsaios);
          const noPeriodo = (registro, campos) => {
            const data = dataRegistroEnsaio(registro, campos);
            return data && data >= inicio && data < fim;
          };
          const ordensDoPeriodo = fontes.ordens.filter((ordem) => {
            const data = dataOrdemServico(ordem);
            return data && data >= inicio && data < fim;
          });
          const tracoes = fontes.tracao.filter((item) => noPeriodo(item, ["dataEnsaio", "dataRelatorio", "criadoEm"]));
          const extracoes = fontes.extracoes.filter((item) => noPeriodo(item, ["dataExtracao", "dataRelatorio", "criadoEm"]));
          const dosagens = fontes.dosagens.filter((item) => noPeriodo(item, ["data", "criadoEm"]));

          const contagem = new Map();
          const adicionar = (tipo, campo, quantidade = 1) => {
            const nome = String(tipo || "Não informado").trim();
            const atual = contagem.get(nome) || { solicitada: 0, realizada: 0 };
            atual[campo] += quantidade;
            contagem.set(nome, atual);
          };

          ordensDoPeriodo.forEach((ordem) => {
            (ordem.ensaios || [])
              .filter((ensaio) =>
                ensaio.status !== "cancelado" &&
                ensaio.id !== "caracterizacaoAgregados"
              )
              .forEach((ensaio) => {
                const tipo = ensaio.nome || ensaio.categoria || ensaio.id;
                adicionar(tipo, "solicitada");
                const status = normalizarChaveObra(ensaio.status);
                if (status === "concluido" || status === "concluida") {
                  adicionar(tipo, "realizada");
                }
              });
          });
          adicionar("Tração", "solicitada", tracoes.length);
          adicionar("Tração", "realizada", tracoes.length);
          adicionar("Extração de testemunhos", "solicitada", extracoes.length);
          adicionar("Extração de testemunhos", "realizada", extracoes.length);
          adicionar("Dosagens", "solicitada", dosagens.length);
          adicionar("Dosagens", "realizada", dosagens.length);

          const todosOsTipos = [...contagem.entries()]
            .filter(([, quantidades]) => quantidades.solicitada > 0)
            .map(([tipo, quantidades]) => ({ tipo, ...quantidades }))
            .sort((a, b) => b.solicitada - a.solicitada);

          setEnsaiosOSSemana({
            tipos: todosOsTipos,
            totalEnsaios: todosOsTipos.reduce((total, item) => total + item.solicitada, 0),
            totalRealizados: todosOsTipos.reduce((total, item) => total + item.realizada, 0),
            totalOrdens: ordensDoPeriodo.length,
            totalCadastros: tracoes.length + extracoes.length + dosagens.length,
            carregando: false,
          });
          atualizarGraficoRupturas(fontes.agenda, fontes.obras).catch((erro) => {
            if (cancelado) return;
            console.error("Erro ao carregar CPs rompidos por obra:", erro);
            setRupturasPorObra({ obras: [], totalCps: 0, carregando: false });
          });
        }

        function ouvirFonte(chave, colecao) {
          const q = query(collection(db, colecao), ...tenantWhere(usuario));
          return onSnapshot(q, (snap) => {
            fontes[chave] = snap.docs.map((item) => ({ id: item.id, ...item.data() }));
            atualizarGrafico();
          }, (erro) => {
            console.error(`Erro ao carregar ${colecao} para o gráfico de ensaios:`, erro);
            fontes[chave] = [];
            atualizarGrafico();
          });
        }

        unsubscribes = [
          ouvirFonte("ordens", "tblSolicitacoesServicos"),
          ouvirFonte("tracao", "tblEnsaiosTracao"),
          ouvirFonte("extracoes", "tblExtracoesTestemunhos"),
          ouvirFonte("dosagens", "tblDosagensConcreto"),
          ouvirFonte("agenda", "tblAgendaRuptura"),
          ouvirFonte("obras", "obras"),
        ];
      } catch (erro) {
        console.error("Erro ao iniciar consultas do gráfico de ensaios:", erro);
        setEnsaiosOSSemana({
          tipos: [],
          totalEnsaios: 0,
          totalRealizados: 0,
          totalOrdens: 0,
          totalCadastros: 0,
          carregando: false,
        });
        setRupturasPorObra({
          obras: [],
          totalCps: 0,
          carregando: false,
        });
      }
    }

    ouvirTodosOsEnsaios();
    return () => {
      cancelado = true;
      unsubscribes.forEach((unsubscribe) => unsubscribe());
    };
  }, [periodoEnsaios, mesEnsaios, periodoRupturas, mesRupturas]);

  const [visible, setVisible] = useState({
    kpis: true,
    ensaios: true,
    ncs: true,
  });

const tipoUsuarioAtual = tipoUsuarioProp || tipoUsuario;
const quickAccessOptions = getAllSidebarItems().filter((item) =>
  !(localStorage.getItem("planoUsuario") === "pessoal" && item.id === "usuarios") &&
  (!Array.isArray(item.tiposPermitidos) || item.tiposPermitidos.includes(tipoUsuarioAtual)) &&
  (!item.somenteAdminPrincipal || podeAcessarItem(item))
);



  const toggle = (id) => {
    setVisible((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  /* ================= RQ-1.3 (ENGINE) ================= */
  useEffect(() => {
    async function carregarRQ13() {
      try {
        const dados = await calcularRQ13();
        setRq13(dados);
      } catch (error) {
        console.error("Erro ao carregar RQ13:", error);
        setRq13(null);
      }
    }
    carregarRQ13();
  }, []);


/* ================= DEBUG NC POR TIPO ================= */
useEffect(() => {
  if (rq13) {
    console.log("RQ13 → NC POR TIPO:", rq13.ncPorTipo);
    console.log("RQ13 COMPLETO:", rq13);
  }
}, [rq13, location.key]);


  /* ================= KPIs DO DASHBOARD ================= */
  useEffect(() => {
  let unsubscribe = () => {};
  let cancelado = false;

  async function ouvirKPIsDashboard() {
  const usuario = await getUsuarioAtualComTenant();
  if (cancelado) return;

  const q = query(
    collection(db, "kpis"),
    ...tenantWhere(usuario),
    where("ativo", "==", true),
    where("mostrarNoDashboard", "==", true)
  );

  unsubscribe = onSnapshot(q, async (snap) => {
    const lista = [];

    for (const docKpi of snap.docs) {
      const kpi = { id: docKpi.id, ...docKpi.data() };

      // ================= KPI DE PESQUISA =================
      if (kpi.tipoKPI === "PESQUISA") {
        const respSnap = await getDocs(
          query(
            collection(db, "kpi_respostas"),
            ...tenantWhere(usuario),
            where("kpiId", "==", kpi.id),
            where("indice", "!=", null)
          )
        );

        const cicloAtual = getCycleMeta(new Date(), kpi.periodicidadeCiclos);
        const respostasCicloAtual = respSnap.docs
          .map((resposta) => resposta.data())
          .filter((resposta) =>
            respostaPertenceAoCicloAtual(resposta, kpi, cicloAtual)
          );

        if (respostasCicloAtual.length === 0) continue;

        let soma = 0;
        respostasCicloAtual.forEach((resposta) => {
          soma += Number(resposta.indice || 0);
        });
        
        
        // 🔥 AMBOS OS TIPOS VÃO PARA A MESMA ROTA:
        lista.push({
          id: kpi.id,
          nome: kpi.nome,
          media: soma / respostasCicloAtual.length,
          totalRespondentes: respostasCicloAtual.length,
          escopo: kpi.escopo,
          icon:
            kpi.escopo === "cliente"
              ? <ThumbUpIcon />
              : <PeopleIcon />,
          onClick: () => history.push(`/admin/kpis/respostas?kpiId=${kpi.id}`) // ← Mesma rota para ambos
        });
      }
         // ================= KPI DE NC (ENGINE) =================
            if (kpi.considerarSomenteNC === true && rq13) {

              // 🔥 COR DA BOLA (Avatar)
              let corNC = "#0d6efd"; // 🔵 azul padrão

              if (rq13.ncForaPrazo > 0) {
                corNC = "#d32f2f"; // 🔴 atraso
              } else if (rq13.ncAbertas > 0 || rq13.ncEmAndamento > 0) {
                corNC = "#f57c00"; // 🟠 abertas / em andamento
              }

              lista.push({
                id: kpi.id,
                nome: kpi.nome,
                valorCustom: rq13.totalNC,
                subtitulo: `Abertas: ${rq13.ncAbertas} | Em andamento: ${rq13.ncEmAndamento} | Fora do prazo: ${rq13.ncForaPrazo}`,
                icon: <ReportProblemIcon sx={{ color: "#fff" }} />, // ícone sempre branco
                corIcone: corNC, // 🔥 AQUI ESTÁ A CHAVE
                onClick: () => history.push("/app/ocorrencias"),
              });
            }

      
    }

    setKpis(lista.filter((kpi) => podeVerKPI(kpi.escopo, tipoUsuarioAtual)));
  });
  }

  ouvirKPIsDashboard().catch((error) => {
    console.error("Erro ao carregar KPIs do dashboard:", error);
    setKpis([]);
  });

  return () => {
    cancelado = true;
    unsubscribe();
  };
}, [rq13, location.key, history, tipoUsuarioAtual]);



  /* ================= DADOS DO GRÁFICO NC ================= */
  const ncsData =
  rq13 &&
  rq13.ncPorTipo &&
  Object.keys(rq13.ncPorTipo).length > 0
    ? {
        labels: Object.keys(rq13.ncPorTipo),
        datasets: [
          {
            data: Object.values(rq13.ncPorTipo),
            backgroundColor: Object.keys(rq13.ncPorTipo).map(
              (_, index) => {
                const cores = [
                  "#d32f2f",
                  "#f57c00",
                  "#1976d2",
                  "#388e3c",
                  "#7b1fa2",
                  "#0288d1",
                  "#c2185b",
                  "#00796b",
                  "#5d4037",
                ];
                return cores[index % cores.length];
              }
            ),
          },
        ],
      }
    : null;

  const ensaiosOSData = {
    labels: ensaiosOSSemana.tipos.map((item) => item.tipo),
    datasets: [
      {
        label: "Quantidade solicitada",
        data: ensaiosOSSemana.tipos.map((item) => item.solicitada),
        backgroundColor: "#0d6efd",
        borderRadius: 4,
      },
      {
        label: "Quantidade realizada",
        data: ensaiosOSSemana.tipos.map((item) => item.realizada),
        backgroundColor: "#2e7d32",
        borderRadius: 4,
      },
    ],
  };

  const rupturasPorObraData = {
    labels: rupturasPorObra.obras.map((item) => item.obra),
    datasets: [
      {
        label: "CPs rompidos",
        data: rupturasPorObra.obras.map((item) => item.quantidade),
        backgroundColor: "#f57c00",
        borderRadius: 4,
      },
    ],
  };


   return (
    <Box sx={{ width: "100%" }}>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 280, p: 2 }}>
          <Typography variant="h6">Configuração</Typography>
          <Divider sx={{ my: 2 }} />
          <FormGroup>
            {Object.keys(visible).map((key) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={visible[key]}
                    onChange={() => toggle(key)}
                  />
                }
                label={key.toUpperCase()}
              />
            ))}
          </FormGroup>
          <Divider sx={{ my: 2 }} />

<Typography variant="subtitle1" fontWeight={600}>
  Acesso rápido
</Typography>

<FormGroup>
  {quickAccessOptions.map(item => (
    <FormControlLabel
      key={item.id}
      control={
        <Checkbox
          checked={quickAccessEnabled.includes(item.id)}
          onChange={() => {
            setQuickAccessEnabled(prev =>
              prev.includes(item.id)
                ? prev.filter(id => id !== item.id)
                : [...prev, item.id]
            );
          }}
        />
      }
      label={item.label}
    />
  ))}
</FormGroup>

        </Box>
      </Drawer>

      {/* ================= KPIs ================= */}
       {visible.kpis && (
     <Grid
    container
    spacing={isMobile ? 1.5 : 3}
    sx={{ mb: isMobile ? 2 : 4 }}
    >
    {kpis.map((kpi) => (
      <Grid item xs={12} sm={6} md={3} key={kpi.id}>
        <KPICard
              titulo={kpi.nome}
              valor={
                kpi.valorCustom !== undefined
                  ? kpi.valorCustom
                  : kpi.media.toFixed(1)
              }
              unidade={kpi.media !== undefined ? "%" : ""}
              subtitulo={
                kpi.subtitulo || `Respondentes: ${kpi.totalRespondentes}`
              }
              icon={kpi.icon}
              corIcone={kpi.corIcone}   // 🔥 AQUI ESTAVA O PROBLEMA
              onClick={kpi.onClick}
            />


      </Grid>
        ))}
    
        </Grid>
    )}


      {/* ================= GRÁFICOS ================= */}
      <Grid container spacing={3}>
        {visible.ensaios && (
          <Grid item xs={12} md={9} sx={{ order: 1 }}>
            <Card
              onClick={() => history.push("/app/solicitacao-servicos")}
              sx={{
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                  mb={0.5}
                >
                  <Typography variant="h6">
                    Ensaios {periodoEnsaios === "mensal" ? "mês" : periodoEnsaios}
                    {periodoEnsaios === "mensal" && ` — ${descricaoMes(mesEnsaios)}`}
                  </Typography>
                  <TextField
                    select
                    size="small"
                    label="Período"
                    value={periodoEnsaios}
                    onClick={(event) => event.stopPropagation()}
                    onChange={(event) => setPeriodoEnsaios(event.target.value)}
                    sx={{ minWidth: 120 }}
                  >
                    <MenuItem value="semanal">Semanal</MenuItem>
                    <MenuItem value="mensal">Mensal</MenuItem>
                    <MenuItem value="anual">Anual</MenuItem>
                  </TextField>
                </Box>
                {periodoEnsaios === "mensal" && (
                  <TextField
                    type="month"
                    size="small"
                    label="Mês exibido"
                    value={mesEnsaios}
                    onClick={(event) => event.stopPropagation()}
                    onChange={(event) => {
                      if (event.target.value) setMesEnsaios(event.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: 170, mb: 1 }}
                  />
                )}
                <Typography variant="body2" color="text.secondary" mb={1}>
                  {ensaiosOSSemana.totalEnsaios} solicitado(s), {ensaiosOSSemana.totalRealizados} realizado(s) em{" "}
                  {ensaiosOSSemana.totalOrdens} ordem(ns) de serviço e{" "}
                  {ensaiosOSSemana.totalCadastros} cadastro(s) direto(s)
                </Typography>
                {ensaiosOSSemana.carregando ? (
                  <Typography color="text.secondary">
                    Carregando dados dos ensaios...
                  </Typography>
                ) : ensaiosOSSemana.tipos.length === 0 ? (
                  <Typography color="text.secondary">
                    Nenhum ensaio neste período.
                  </Typography>
                ) : (
                  <Box sx={{ height: 260 }}>
                    <Bar
                      data={ensaiosOSData}
                      options={{
                        indexAxis: "y",
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: true },
                        },
                        scales: {
                          x: {
                            beginAtZero: true,
                            ticks: { precision: 0 },
                            title: {
                              display: true,
                              text: "Quantidade",
                            },
                          },
                          y: {
                            ticks: { autoSkip: false },
                          },
                        },
                      }}
                    />
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        )}

        {visible.ensaios && (
          <Grid item xs={12} md={12} sx={{ order: 3 }}>
            <Card
              onClick={() => history.push("/app/agendamoldagem")}
              sx={{
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                  mb={0.5}
                >
                  <Typography variant="h6">
                    Rupturas por obra {periodoRupturas}
                    {periodoRupturas === "mensal" && ` — ${descricaoMes(mesRupturas)}`}
                  </Typography>
                  <TextField
                    select
                    size="small"
                    label="Período"
                    value={periodoRupturas}
                    onClick={(event) => event.stopPropagation()}
                    onChange={(event) => setPeriodoRupturas(event.target.value)}
                    sx={{ minWidth: 120 }}
                  >
                    <MenuItem value="semanal">Semanal</MenuItem>
                    <MenuItem value="mensal">Mensal</MenuItem>
                    <MenuItem value="anual">Anual</MenuItem>
                  </TextField>
                </Box>
                {periodoRupturas === "mensal" && (
                  <TextField
                    type="month"
                    size="small"
                    label="Mês exibido"
                    value={mesRupturas}
                    onClick={(event) => event.stopPropagation()}
                    onChange={(event) => {
                      if (event.target.value) setMesRupturas(event.target.value);
                    }}
                    InputLabelProps={{ shrink: true }}
                    sx={{ width: 170, mb: 1 }}
                  />
                )}
                <Typography variant="body2" color="text.secondary" mb={1}>
                  Total: {rupturasPorObra.totalCps} CP(s) com resultado de ruptura em{" "}
                  {rupturasPorObra.obras.length} obra(s)
                </Typography>
                {rupturasPorObra.carregando ? (
                  <Typography color="text.secondary">Carregando rupturas...</Typography>
                ) : rupturasPorObra.obras.length === 0 ? (
                  <Typography color="text.secondary">Nenhuma ruptura neste período.</Typography>
                ) : (
                  <Box sx={{ height: Math.max(240, rupturasPorObra.obras.length * 50) }}>
                    <Bar
                      data={rupturasPorObraData}
                      options={{
                        indexAxis: "y",
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: false },
                        },
                        scales: {
                          y: {
                            ticks: {
                              autoSkip: false,
                              callback(value) {
                                return quebrarRotuloGrafico(this.getLabelForValue(value));
                              },
                            },
                          },
                          x: {
                            beginAtZero: true,
                            ticks: { precision: 0 },
                            title: {
                              display: true,
                              text: "Quantidade de CPs rompidos",
                            },
                          },
                        },
                      }}
                    />
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        )}

        {tipoUsuarioAtual !== "colaborador" && visible.ncs && ncsData && (
    <Grid item xs={12} md={3} sx={{ order: 2 }}>
    <Card
    onClick={() => history.push("/app/ocorrencias")} // ← Adicione navegação se quiser
           sx={{
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: 6,
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardContent sx={{ height: 220 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          NCs por Tipo
        </Typography>

        <Box sx={{ height: 160 }}>
          <Doughnut
            data={ncsData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              cutout: "65%",
            }}
          />
        </Box>
      </CardContent>
    </Card>
    </Grid>
  )}

      </Grid>
    </Box>
 );
}
